import React, { useState } from "react";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";

const TenderSearch = ({ setSearchTerm, title }) => {
  const [text, setText] = useState("");
  const { getText } = useLanguageTranslation();
  return (
    <div className="form-group">
      {/* <label htmlFor="edit-title">{title}</label> */}
      <div className="form-inline">
        <input
          placeholder={title}
          className="form-control"
          autoComplete="off"
          type="text"
          id="edit-title"
          name="title"
          size="30"
          maxLength="128"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <button
          className="ml-2 quick-btn quick-100"
          type="submit"
          id="edit-reset"
          onClick={() => setSearchTerm(text)}
        >
          {getText("Submit", "सबमिट करे")}
        </button>
        <button
          className="quick-btn clear-btn ml-2"
          type="reset"
          id="edit-reset"
          onClick={() => {
            setSearchTerm("");
            setText("");
          }}
        >
          {getText("Clear", "हटाएँ")}
        </button>
      </div>
    </div>
  );
};

export default TenderSearch;
